'use strict';

/**
 * @ngdoc function
 * @name thothApp.directives:scopeChangeFile
 * @description
 * # scopeChangeFile Directive
 * Expone en el scope el archivo elegido en un input type="file". ngModel no
 * funciona con inputs de archivo, por eso hace falta la directiva.
 *
 * Con max-size-mb rechaza los archivos que pasen ese peso y deja el motivo en
 * <nombre>Error para que la vista lo muestre.
 */

angular.module('thothApp.directives')
.directive('scopeChangeFile', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var target = attrs.scopeChangeFile;
      var maxMb = parseInt(attrs.maxSizeMb, 10);

      element.on('change', function() {
        scope.$apply(function() {
          var file = element[0].files[0];
          scope[target + 'Error'] = null;

          if (file && maxMb && file.size > maxMb * 1024 * 1024) {
            scope[target + 'Error'] = 'El archivo pesa más de ' + maxMb + ' MB. Elija uno más pequeño.';
            scope[target] = null;
            element.val('');
            return;
          }

          scope[target] = file;
        });
      });

      scope.$on('$destroy', function() {
        element.off('change');
      });
    }
  };
});
